export const orderAddressReducerInitialState = {
  addressHistory: [],
  orderHistory: [],
  currentOrderDetails: null,
  selectedAddress: null,
};
